export default {
  Auth: {
    identityPoolId: 'eu-west-1:3111261a-2313-4a0e-8550-c8e2eaf83783',
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0BMVBQA3i',
    userPoolWebClientId: '1umd8u9p3id9vt4tjjvhij9cij',
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  API: {
    aws_appsync_graphqlEndpoint: 'https://rwxv55hkpnau7kgv2g7uo5v5pa.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  },
  Storage: {
    AWSS3: {
      bucket: 'op-dev-cognito',
      region: 'eu-west-1',
    },
  },
}
